import React from 'react';
import { TestEyeIcon } from 'icons';

interface IProps {
  onOpen: () => void;
}

const TestTime: React.FC<IProps> = ({ onOpen }) => (
  <div
    onClick={onOpen}
    className="flex cursor-pointer items-center justify-center gap-1 rounded-lg border-b border-b-green-300 bg-green-50 px-3 py-1.5 shadow-[inset_0px_2px_4px_0px_#B7DDC961]"
  >
    <TestEyeIcon />
  </div>
);

export default TestTime;
